module.exports = __webpack_public_path__ + "img/emojis-blisser-same.eefc1662.png";